
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag';
import SortDrawer from '~/components/SortDrawer.vue';
import BottomDrawerDialog from '~/components/UIComponents/BottomDrawerDialog.vue';
import { availableLocales, getCurrentLocale } from '../utils/locales';

@Component({ components: { SortDrawer, BottomDrawerDialog, CountryFlag } })
export default class LanguageSwitcher extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isRegistrationModal!: boolean;

  showLanguagesDropdown = false;
  selectedLocale = {
    code: 'en',
    flagCode: 'us',
    file: 'en_US.json',
    name: 'English',
    displayText: 'EN',
  };

  created() {
    const localeInfo = {
      localeCookie: this.$i18n.getLocaleCookie(),
      browserLocale: this.$i18n.getBrowserLocale(),
      locales: this.$i18n.locales,
    };
    this.selectedLocale = getCurrentLocale(localeInfo);
  }

  mounted() {
    if (!this.isRegistrationModal) {
      // This allows the LanguageSwitcher in GalaFooter to listen for language changes made by the LanguageSwitcher in the new user registration modal
      this.$root.$on('languageSwitched', () => {
        const localeInfo = {
          localeCookie: this.$i18n.getLocaleCookie(),
          browserLocale: this.$i18n.getBrowserLocale(),
          locales: this.$i18n.locales,
        };
        this.selectedLocale = getCurrentLocale(localeInfo);
      });
    }
  }

  beforeDestroy() {
    if (!this.isRegistrationModal) {
      this.$root.$off('languageSwitched');
    }
  }

  orderedLocales() {
    const orderedLocales = availableLocales(this.$i18n.locales).slice();
    let indexToRemove;
    let removedItem;

    for (const index in orderedLocales) {
      if (orderedLocales[index].code === this.selectedLocale.code) {
        indexToRemove = index;
      }
    }

    if (indexToRemove) {
      removedItem = orderedLocales[indexToRemove];
      orderedLocales.splice(indexToRemove, 1);
      if (this.isRegistrationModal) {
        orderedLocales.unshift(removedItem);
      } else {
        orderedLocales.push(removedItem);
      }
    }

    return orderedLocales;
  }

  toggleLanguageOptions() {
    this.showLanguagesDropdown = !this.showLanguagesDropdown;
  }

  handleLanguageSelected() {
    setTimeout(() => {
      const localeInfo = {
        localeCookie: this.$i18n.getLocaleCookie(),
        browserLocale: this.$i18n.getBrowserLocale(),
        locales: this.$i18n.locales,
      };
      this.selectedLocale = getCurrentLocale(localeInfo);
      this.showLanguagesDropdown = false;
      if (this.isRegistrationModal) {
        // This triggers the update of the language switcher in GalaFooter
        this.$root.$emit('languageSwitched');
      }

      this.$store.dispatch('cmsContent/loadCmsContent', {
        i18n: this.$i18n,
        sentry: this.$sentry,
      });
    }, 200);
  }
}
